import Box from "@mui/material/Box"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import Switch from "@mui/material/Switch"
import Tooltip from "@mui/material/Tooltip"
import { type FieldComponentProps, useField } from "@w3rone/json-schema-form"
import { FormErrors } from "./FormErrors"
import Info from "@mui/icons-material/Info"
import { match } from "ts-pattern"
import Checkbox from "@mui/material/Checkbox"

export const CheckboxField = ({ name }: FieldComponentProps) => {
  const {
    value: valueProps,
    schema,
    errors,
    label,
    description,
    onChange,
  } = useField(name)

  const value = Boolean(valueProps)

  const control = match(schema.options.layout)
    .with("checkbox", () => (
      <Checkbox
        disabled={schema.readOnly}
        name={name}
        checked={value}
        onChange={(e) => onChange?.(e.target.checked)}
      />
    ))
    .otherwise(() => (
      <Switch
        disabled={schema.readOnly}
        name={name}
        checked={value}
        onChange={(e) => onChange?.(e.target.checked)}
      />
    ))

  return (
    <div>
      <FormControl error={errors.length > 0}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FormControlLabel control={control} label={label} />
          {description ? (
            <Tooltip
              title={<div dangerouslySetInnerHTML={{ __html: description }} />}
            >
              <Info />
            </Tooltip>
          ) : null}
        </Box>
        <FormErrors errors={errors} />
        {schema.readOnly && value ? (
          <input type="hidden" name={name} value="on" />
        ) : null}
      </FormControl>
    </div>
  )
}
